<script>
  import { fly } from "svelte/transition";

  import { getNextInputId } from "../../helper/UIHelper";
  import { getIndexByAttr } from "../../helper/ListExtensions";
  import { Badge } from "../display";

  import Input from "./Input.svelte";

  export let model; // []
  export let list;
  export let label;
  export { className as class };

  let className = "";
  let enterdText = "";
  let showList = false;
  let filterdList = list;
  let customEntryCount = 0;
  let showAddCustomEntry = false;

  let uid = getNextInputId();

  function onEntrySelect(entry) {
    model = [...model, entry];
    clear();
  }

  function removeTag(entry) {
    const index = getIndexByAttr(model, "Value", entry.Value);
    model.splice(index, 1);
    model = model;
  }

  function onInputKeyUp() {
    showAddCustomEntry = enterdText.length > 0;
    buildFilteredList();
  }
  function onInputFocus() {
    showList = true;
    buildFilteredList();
  }

  function onInputBlur() {
    showList = false;
  }

  function addCustomEntry() {
    customEntryCount++;
    onEntrySelect({ Value: 0 - customEntryCount, Text: enterdText });
  }

  function clear() {
    enterdText = "";
    buildFilteredList();
    showAddCustomEntry = false;
    document.getElementById(uid).focus();
  }

  function buildFilteredList() {
    filterdList = [];

    let filter = enterdText.toUpperCase();

    for (let i = 0; i < list.length; i++) {
      const entry = list[i];
      if (getIndexByAttr(model, "Value", entry.Value) == -1) {
        if (entry.Text.toUpperCase().indexOf(filter) > -1) {
          filterdList = [...filterdList, entry];
        }
      }
    }
  }
</script>

<div class="{className} relative">
  {#if label != null}
    <label for={uid} class="block text-sm font-medium leading-5 text-gray-700">
      {label}
    </label>
  {/if}
  {#each model as entry}
    <Badge class="mr-2">
      <span>{entry.Text}</span>
      <button
        type="button"
        class="ml-1"
        on:click={() => {
          removeTag(entry);
        }}>
        x
      </button>
    </Badge>
  {/each}
  <Input
    {uid}
    bind:model={enterdText}
    on:keyup={() => {
      onInputKeyUp();
    }}
    on:focus={() => {
      onInputFocus();
    }}
    on:blur={() => {
      onInputBlur();
    }} />
  {#if showList}
    <ul
      class="origin-top-left absolute right-0 mt-2 w-full rounded-md shadow-lg
      z-50 bg-white"
      transition:fly>
      {#each filterdList as entry}
        <li
          class="px-2 py-4 cursor-pointer hover:bg-gray-200"
          on:click={() => {
            onEntrySelect(entry);
          }}>
          {entry.Text}
        </li>
      {/each}
      {#if showAddCustomEntry}
        <li
          class="px-2 py-4 cursor-pointer hover:bg-gray-200"
          on:click={() => {
            addCustomEntry();
          }}>
          Add new entry "{enterdText}"
        </li>
      {/if}
    </ul>
  {/if}
</div>
